var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatedByStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22309 12V11.3333C9.22309 10.3999 9.22309 9.9332 9.04143 9.57668C8.88165 9.26308 8.62668 9.00811 8.31307 8.84832C7.95656 8.66667 7.48984 8.66667 6.55642 8.66667H4.11198C3.17856 8.66667 2.71185 8.66667 2.35533 8.84832C2.04172 9.00811 1.78676 9.26308 1.62697 9.57668C1.44531 9.9332 1.44531 10.3999 1.44531 11.3333V12M9.22309 3.66667L10.3342 4.77778L12.5564 2.55556M7.27865 4.5C7.27865 5.57389 6.40809 6.44445 5.3342 6.44445C4.26031 6.44445 3.38976 5.57389 3.38976 4.5C3.38976 3.42611 4.26031 2.55556 5.3342 2.55556C6.40809 2.55556 7.27865 3.42611 7.27865 4.5Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedByStar);
export default __webpack_public_path__ + "a09fb99fb3d3e1b30aa8bbb6a19dd903.svg";
export { ForwardRef as ReactComponent };